export default "__VITE_ASSET__283d03d1__"